//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const StaffProfile = createAsyncThunk(
  "StaffProfile",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingStaffProfile(""));
      const response = await UsePortalApi(
        `Patient/StaffProfile`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
       dispatch(gettingStaffProfileSuccess(response)) 
      } else {
        dispatch(
          gettingStaffProfileFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingStaffProfileFailed(error));
    }
  }
);
const StaffProfileSlice = createSlice({
  name: "StaffProfile",
  initialState: {
    StaffProfileData: null,
    isStaffProfileLoading: false,
    isStaffProfileError: false,
  },
  reducers: {
    gettingStaffProfile: (state, action) => {
      state.StaffProfileData = null;
      state.isStaffProfileLoading = true;
      state.isStaffProfileError = false;
    },
    gettingStaffProfileSuccess: (state, action) => {
      console.log(action.payload ,"StaffProfileData11")
      state.StaffProfileData = action.payload;
      state.isStaffProfileLoading = false;
      state.isStaffProfileError = false;
    },
    gettingStaffProfileFailed: (state, action) => {
      state.StaffProfileData = null;
      state.isStaffProfileLoading = false;
      state.isStaffProfileError = true;
    },
    gettingStaffProfileClear: (state, action) => {
      state.StaffProfileData = null;
      state.isStaffProfileLoading = false;
      state.isStaffProfileError = false;
    },
  },
});
export const {
  gettingStaffProfile,
  gettingStaffProfileSuccess,
  gettingStaffProfileFailed,
  gettingStaffProfileClear,
} = StaffProfileSlice.actions;
export default StaffProfileSlice.reducer;
